import React from "react";
import { Eexi } from "./Eexi";
import { EexiData } from "../../types/EexiData";
import { CiiData } from "../../types/CiiData";
import { Cii } from "./Cii";

type Props = {
    ciiData: CiiData | null;
    eexiData: EexiData | null;
    paragraph: string | null;
};

export const Decarbonisation = (props: Props) => {
    const { ciiData, eexiData, paragraph } = props;

    return (
        <div className="grid">
            {paragraph ? (
                <div className="col-12 md:col-6">{paragraph}</div>
            ) : null}
            <div className="col-12 md:col-6">
                {eexiData ? <Eexi eexiData={eexiData} /> : null}
                {ciiData ? <Cii ciiData={ciiData} /> : null}
            </div>
        </div>
    );
};
